<script lang="ts">
type OverflowMenuProps = {
    gap: 20
}

</script>

<script setup lang="ts">
import { useResizeObserver, useTemplateRefsList } from '@vueuse/core'
import { computed, ref, useTemplateRef } from 'vue'

const containerRef = useTemplateRef<HTMLUListElement>("containerRef")
const listRef = useTemplateRef<HTMLUListElement>("listRef")
const listItemsRef = useTemplateRefsList<HTMLLIElement>()

const {
    gap = 20
} = defineProps<OverflowMenuProps>()

const containerWidth = ref<number>()
const listWidth = ref<number>()
const listItemsWidth = ref<number[]>([])
const spaceForList = ref<number[]>([])

useResizeObserver(containerRef, (entries) => {

    const entry = entries[0]
    const { width } = entry.contentRect
    containerWidth.value = Math.floor(width)
    listWidth.value = Math.floor(listRef.value?.getBoundingClientRect().width ?? 0)
    listItemsWidth.value = listItemsRef.value.map((item) => {
        return Math.floor(item.getBoundingClientRect().width)
    })
    listItemsRef.value
        .forEach((_, index) => {
            spaceForList.value[index] = spaceFor(index)
    })
})

const listItemsCount = computed(() => listItemsRef.value.length)
const listItemsWidthSum = computed(() => listItemsWidth.value.reduce((sum, item) => sum + item, 0))
// const gapWidth = computed(() => {
//     if (listItemsCount.value <= 1 || listWidth.value == null) {
//         return 0
//     }

//     return (listWidth.value - listItemsWidthSum.value) / (listItemsCount.value - 1)
// })

function spaceFor(index : number) {
    const width = listItemsWidth.value
        .slice(0, index + 1)
        .reduce((sum, width) => sum + width, 0)
    const gapWidths = gap * index

    return (containerWidth.value ?? 0) - (width + gapWidths)
}
</script>

<template>
    <nav ref="containerRef">
        <ul ref="listRef">
            <li
                :key="index"
                v-for="(item, index) in $slots?.default?.() ?? []"
                :class="{ hide: spaceForList[index] < 0 }"
            >
                <div :ref="listItemsRef.set">
                    <component :is="item" />
                </div>
            </li>
        </ul>
    </nav>
</template>

<style lang="scss">
@use "@/scss/framework" as *;

@layer components.overflow-menu {

    .overflow-menu {
        --overflow-menu-gap: v-bind(gap);
    }
}
</style>
